import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i1 from '@upr-web-primer/dal';
import { DalModule } from '@upr-web-primer/dal';
import { HttpHeaders } from '@angular/common/http';
import * as i2 from '@upr-web-primer/storage';
import { sortBy, map } from 'lodash-es';
class MsUtilsModule {
  static {
    this.ɵfac = function MsUtilsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MsUtilsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MsUtilsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DalModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MsUtilsModule, [{
    type: NgModule,
    args: [{
      imports: [DalModule]
    }]
  }], null, null);
})();
const relativeUrls = {
  PREFIX: '/prefixes',
  COUNTRY: '/countries',
  STATE: '/states?country_code=US'
};
class UtilsService {
  constructor(dalService, localStorage, relativeUrls, defaultValues) {
    this.dalService = dalService;
    this.localStorage = localStorage;
    this.relativeUrls = relativeUrls;
    this.defaultValues = defaultValues;
  }
  loadCountryList() {
    return this.dalService.httpRequest(relativeUrls.COUNTRY, 'GET', null, this.getHeaders()).then(countriesData => {
      if (!countriesData) {
        return [];
      }
      const countryList = sortBy(countriesData, ['name']);
      return map(countryList, value => {
        return {
          id: value.code,
          name: value.name,
          iso3Code: value.iso3
        };
      });
    }).catch(error => {
      throw error;
    });
  }
  loadUsStateList() {
    return this.dalService.httpRequest(relativeUrls.STATE, 'GET', null, this.getHeaders()).then(stateResponse => {
      const stateList = sortBy(stateResponse, ['name']);
      return map(stateList, state => {
        return {
          id: state.code,
          name: state.name
        };
      });
    }).catch(error => {
      throw error;
    });
  }
  loadPrefixes() {
    return this.dalService.httpRequest(relativeUrls.PREFIX, 'GET', null, this.getHeaders(), 0, true);
  }
  validateEmail(emailId, timeout) {
    const request = {
      marketingId: this.defaultValues.SOURCE_MARKETING_ID,
      email: emailId
    };
    const url = this.relativeUrls.VALIDATE_EMAIL;
    return this.dalService.httpRequest(url, 'POST', request, this.getHeaders(), timeout);
  }
  getHeaders() {
    let httpHeaders = new HttpHeaders();
    const instanceId = this.localStorage.getItem('InteractGuestId');
    if (instanceId) {
      httpHeaders = httpHeaders.set('x-instance-id', instanceId);
    }
    return httpHeaders;
  }
  static {
    this.ɵfac = function UtilsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UtilsService)(i0.ɵɵinject(i1.DalService), i0.ɵɵinject(i2.LocalStorageService), i0.ɵɵinject('RelativeUrls'), i0.ɵɵinject('DefaultValues'));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UtilsService,
      factory: UtilsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DalService
  }, {
    type: i2.LocalStorageService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['RelativeUrls']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultValues']
    }]
  }], null);
})();

/*
 * Public API Surface of ms-utils
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MsUtilsModule, UtilsService };
